import { jsx as _jsx } from "react/jsx-runtime";
import { Close as CloseIcon } from "@mui/icons-material";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers-pro";
import { IconButton, TextField } from "@mui/material";
import moment from "moment";
import React from "react";
import { useLocale } from "../LocaleProvider.js";
export const DatePickerMui = ({ disabled, label, value, minValue, maxValue, onChange, disablePast = false, disableFuture = false, ...otherProps }) => {
    const locale = useLocale();
    const format = moment.localeData(locale).longDateFormat("L");
    return (_jsx(MuiDatePicker, { value: value, onChange: (date) => {
            onChange(null, date);
        }, label: label, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, minDate: minValue, maxDate: maxValue, views: ["year", "month", "day"] }));
};
const convertToNativeDatePickerFormat = (date) => {
    return date ? date?.format(moment.HTML5_FMT.DATE) : "";
};
export const DatePickerNative = ({ disabled, label, value, minValue, maxValue, onChange, isClearable = false, disablePast = false, disableFuture = false, inputProps, InputProps, InputLabelProps, ...otherProps }) => {
    const min = React.useMemo(() => {
        if (minValue)
            return convertToNativeDatePickerFormat(minValue);
        if (disablePast)
            return convertToNativeDatePickerFormat(moment());
        return undefined;
    }, [minValue, disablePast]);
    const max = React.useMemo(() => {
        if (maxValue)
            return convertToNativeDatePickerFormat(maxValue);
        if (disableFuture)
            return convertToNativeDatePickerFormat(moment());
        return undefined;
    }, [maxValue, disableFuture]);
    return (_jsx(TextField, { type: "date", label: label, disabled: disabled, value: convertToNativeDatePickerFormat(value), onChange: (e) => {
            const date = e.target.value ? moment(e.target.value) : null;
            onChange(e, date && date.isValid() ? date : null);
        }, ...otherProps, slotProps: {
            input: {
                endAdornment: isClearable ? (value ? (_jsx(IconButton, { size: "small", color: "primary", onClick: () => {
                        onChange(null, null);
                    }, "aria-label": "Clear", style: { position: "relative", top: 8 }, children: _jsx(CloseIcon, { fontSize: "small" }) })) : undefined) : undefined,
                ...InputProps,
            },
            htmlInput: {
                min,
                max,
                ...inputProps,
            },
            inputLabel: {
                shrink: true,
                ...InputLabelProps,
            },
        } }));
};
export const DatePicker = ({ browserHasInputDate, ...props }) => {
    return browserHasInputDate ? (_jsx(DatePickerNative, { ...props })) : (_jsx(DatePickerMui, { ...props }));
};
//# sourceMappingURL=DatePicker.js.map